import { createSlice } from '@reduxjs/toolkit';
import { categoryAction } from '../actions';
import { categoryReducer as extraReducers } from '../reducers';
import { ICategoryState } from '../../interfaces';

const initialState: ICategoryState = {
  status: 'inactive',
  categories: [],
  error: '',
};

export const categorySlice = createSlice({
  name: 'category',
  initialState,
  // Non-async reducers
  reducers: {
    resetCategory: () => {
      return initialState;
    },
  },
  // Async reducers
  extraReducers,
});

// Action creators are generated for each case reducer function
export const categorySliceActions = { ...categorySlice.actions, ...categoryAction };

export default categorySlice.reducer;
